import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-add',
  templateUrl: './info-add.component.html',
  styleUrls: ['./info-add.component.scss']
})
export class InfoAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
